import { render } from "./VerificationStep2.vue?vue&type=template&id=5c1219b5"
import script from "./VerificationStep2.vue?vue&type=script&lang=js"
export * from "./VerificationStep2.vue?vue&type=script&lang=js"
script.render = render

export default script